export function validCoordinates(latitude, longitude) {
  return typeof latitude === "number" && typeof longitude === "number" && Number.isFinite(latitude) && Number.isFinite(longitude) && Math.abs(latitude) <= 90 && Math.abs(longitude) <= 180;
}

export function distanceMiles(latitude, longitude, centerLatitude, centerLongitude) {
  const radians = value => value * Math.PI / 180;
  const a = Math.sin(radians(latitude - centerLatitude) / 2) ** 2 + Math.cos(radians(centerLatitude)) * Math.cos(radians(latitude)) * Math.sin(radians(longitude - centerLongitude) / 2) ** 2;
  return 3958.7613 * 2 * Math.atan2(Math.sqrt(Math.min(1, a)), Math.sqrt(Math.max(0, 1 - a)));
}

export function deliveryLocationError(area, latitude, longitude) {
  if (!validCoordinates(area.centerLatitude, area.centerLongitude) || !Number.isFinite(area.radiusMiles) || area.radiusMiles <= 0) return "This delivery area is not configured yet. Please select another area.";
  if (!validCoordinates(latitude, longitude)) return "Select your delivery address on the map before placing your order.";
  if (distanceMiles(latitude, longitude, area.centerLatitude, area.centerLongitude) > area.radiusMiles + 1e-9) return `This address is outside the ${area.radiusMiles} mile delivery radius for ${area.name}. Please select an address within the allowed radius.`;
  return "";
}
